import * as React from "react";
const SvgLockedLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M17 6a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3v2a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2zm-2 2V6a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v2zm2 2H7v9h10z", clipRule: "evenodd" }));
export default SvgLockedLine;
